import { useState } from 'react';

export function DateRangePicker({ from, to, onApply }: {
  from: string;
  to: string;
  onApply: (from: string, to: string) => void;
}) {
  const [f, setF] = useState(from);
  const [t, setT] = useState(to);

  return (
    <div className="toolbar">
      <input className="input" type="date" value={f} onChange={e => setF(e.target.value)} aria-label="From date" />
      <span style={{ color: 'var(--kt-grey-400)' }}>to</span>
      <input className="input" type="date" value={t} onChange={e => setT(e.target.value)} aria-label="To date" />
      <button className="btn-secondary btn-sm" onClick={() => onApply(f, t)} disabled={!f || !t}>
        Apply
      </button>
    </div>
  );
}
